// extracted by mini-css-extract-plugin
export default {"container":"CR-z","topReviewHeading":"DR-z","criticalReview":"ER-z","favorableReview":"FR-z","vsSeparator":"GR-z"};